export enum Tenant {
    SG = 'sg',
    AU = 'au',
    ESS = 'ess',
    CN = 'cn',
    HK = 'hk',
    FR = 'fr',
    DMAAS = "dmaas",
    DFAM = "dfam",
    JPCORP = "jpcorp"
};
